// to use this we expect firebase to have been initialized via the firebase app global.
// implicitly, the first app that is intiialized is the one that gets used

// the firebase event hub has the same interface as http://backbonejs.org/#Events
// "trigger" should not be called, except based on firebase event changes,
// and all that logic should be encapsulated in the firebase_events module

import extend from 'lodash/extend';
import Backbone from 'backbone';

import { connectFirebaseEventsToHub } from 'zoomforth_tools/firebase_events.js';

var firebaseEventHub;

export const initFirebaseEventHub = ()=> {
  if (!firebaseEventHub) {
    firebaseEventHub = extend({}, Backbone.Events);
    connectFirebaseEventsToHub(firebaseEventHub);
  }
  return firebaseEventHub;
};

export const getFirebaseEventHub = ()=> {
  if (!firebaseEventHub) {
    initFirebaseEventHub();
  }
  return firebaseEventHub;
}
